<template>
  <h3>Lista formulários</h3>
  <div class="row" style="margin-bottom: 1%">
    <div class="col-3">
      <label for="cpf">CPF</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" v-model="cpf" v-mask="'###.###.###-##'" ref="cpf" />
      </div>
    </div>
    <div class="col-sm-1" style="width: 6%">
      <div class="input-group-prepend" style="margin-top: 25px">
        <span class="input-group-text bg-white" @click="search"><i class="fa fa-search"></i></span>
      </div>
    </div>
  </div>
  <a-table :dataSource="todosFormularios" :columns="columns">
    <template #nomeForm="{ record }">
      <span>{{ stringNomeForm(record) }}</span>
    </template>
    <template #nomeUsuario="{ record }">
      <span>{{ stringNomeUsuario(record) }}</span>
    </template>
    <template #cpfUsuario="{ record }">
      <span>{{ formatarCpf(record.cpfUsuario) }}</span>
    </template>
    <template #dataCriacao="{ record }">
      <span>{{ stringDataCriacao(record) }}</span>
    </template>
    <template #dataAlteracao="{ record }">
      <span>{{ record.dataAlteracao ? stringDataAlteracao(record) : '' }}</span>
    </template>
    <template #action="{ record }">
      <a @click="editar(record)" style="margin: 5px"><i class="fas fa-pen"></i></a>

      <a @click="vizualizar(record)" style="margin: 5px"><i class="fas fa-eye"></i></a>
    </template>
  </a-table>
</template>

<script>
import { getFormsBuilder } from '@/components/service/formBuilderService';
import { formatCpf, validarCpf } from '@/utils/servicos-utils';

export default {
  name: 'ListaFormulario',

  data() {
    return {
      todosFormularios: [],
      todosFormulariosOriginal: [],
      columns: [
        {
          title: 'Nome',
          dataIndex: 'nomeForm',
          key: 'nomeForm',
          slots: { customRender: 'nomeForm' },
        },
        {
          title: 'Usuário',
          dataIndex: 'nomeUsuario',
          key: 'nomeUsuario',
          slots: { customRender: 'nomeUsuario' },
        },
        {
          title: 'CPF',
          dataIndex: 'cpfUsuario',
          key: 'cpfUsuario',
          slots: { customRender: 'cpfUsuario' },
        },
        {
          title: 'Data Criação',
          dataIndex: 'dataCriacao',
          key: 'dataCriacao',
          slots: { customRender: 'dataCriacao' },
        },
        {
          title: 'Data Alteração',
          dataIndex: 'dataAlteracao',
          key: 'dataAlteracao',
          slots: { customRender: 'dataAlteracao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    await this.getFormsBuilder();
    this.todosFormulariosOriginal = this.todosFormularios.slice();
  },
  methods: {
    async getFormsBuilder() {
      await getFormsBuilder().then((esp) => {
        this.todosFormularios = esp.data;
      });
    },

    async search() {
      let value = this.$refs.cpf.value;
      if (validarCpf(value)) {
        const filtro = this.cpf.replace(/[^\d]/g, '');
        const cpfFiltrado = this.todosFormulariosOriginal.filter((formulario) => formulario.cpfUsuario === filtro);
        this.todosFormularios = cpfFiltrado;
      } else {
        this.todosFormularios = this.todosFormulariosOriginal.slice();
      }
    },

    watch: {
      cpf() {
        this.search();
      },
    },

    editar(formBuilder) {
      this.$router.push({ path: '/edit-page-form-builder', query: { id: formBuilder.id } });
    },

    vizualizar(formBuilder) {
      this.$router.push({ path: '/view-page-form-builder', query: { id: formBuilder.id } });
    },

    formatarCpf(cpf) {
      return formatCpf(cpf);
    },

    stringNomeForm(record) {
      return record.nomeForm;
    },
    stringNomeUsuario(record) {
      return record.nomeUsuario;
    },
    stringDataCriacao(record) {
      const dataCriacao = new Date(record.dataCriacao);
      return `${dataCriacao.toLocaleDateString()} ${dataCriacao.toLocaleTimeString('pt-BR')}`;
    },
    stringDataAlteracao(record) {
      const dataAlteracao = new Date(record.dataAlteracao);
      return `${dataAlteracao.toLocaleDateString()} ${dataAlteracao.toLocaleTimeString('pt-BR')}`;
    },
  },
};
</script>

<style scoped></style>
